export default function convertNodeListToArray(nodeList) {
    if (Array.from) {
        return Array.from(nodeList);
    }
    return Array.prototype.slice.call(nodeList);
}
